#import "../../../../core/email-marketing/graphql/fragments/em-from-address-fragment.graphql"

mutation SharedEmailAddressUpdate($input: SharedEmailAddressUpdateInput!) {
    sharedEmailAddressUpdate(input: $input) {
        fromAddress {
            ...FromAddress
        }
    }
}
